import React from "react";
import { FiAlertTriangle } from "react-icons/fi";

import "./FrozenCompanyBanner.scss";

interface FrozenCompanyBannerProps {
  /** companyById.freezeDetails.status. */
  freezeStatus?: string | null;
}

const FrozenCompanyBanner = ({ freezeStatus }: FrozenCompanyBannerProps) => {
  // PENDING_UNFREEZE clears EmployerInfo's Unfreeze button (an unfreeze has
  // been requested and is awaiting approval) but the employer stays frozen
  // until that approval lands, so the banner outlives the button here.
  const isFrozen =
    freezeStatus === "FROZEN" || freezeStatus === "PENDING_UNFREEZE";

  if (!isFrozen) {
    return null;
  }

  return (
    <div className="frozen-company-banner" role="alert">
      <FiAlertTriangle
        className="frozen-company-banner-icon"
        size={20}
        aria-hidden="true"
      />
      <p className="frozen-company-banner-message">
        This employer is currently frozen.
        {freezeStatus === "PENDING_UNFREEZE" &&
          " There is a pending unfreeze approval request waiting for review."}
      </p>
    </div>
  );
};

export default FrozenCompanyBanner;
